<template>
  <div class="animated fadeIn">
    <b-modal
      ref="addressModal"
      title="주소찾기!"
      hide-footer
    >
      <DaumPostcode
        :on-complete="setAddress"
        :default-query="''"
        :script-url="'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'"
      />
    </b-modal>
    <b-row>
      <b-col md="3">
        <!--FAILED-->
        <div
          v-if="isFileFailed"
          class="text-center"
        >
          <h4>사진 등록 실패</h4>
          <button
            class="btn btn-warning btn-md"
            @click="fileReset()"
          >
            다시 등록
          </button>
        </div>
        <!--SUCCESS-->
        <div
          v-if="!isFileSuccess && !isFileFailed"
          class="dropbox text-center"
        >
          <input
            type="file"
            :name="uploadFieldName"
            :disabled="!isFileInitial || freezing"
            class="input-file"
            accept="image/*"
            @change="filesChange($event.target.name, $event.target.files);
                     fileCount = $event.target.files.length"
          >
          <p v-if="freezing">
            email 체크후 사진 등록 가능합니다. <br> (Can upload a photo after checking email duplication.)
          </p>
          <p v-else-if="isFileInitial">
            사진을 고르기 위해 클릭! (Click to browse)
          </p>
          <p v-if="isFileSaving">
            Uploading the photo file...
          </p>
        </div>
        <div
          v-if="isFileSuccess"
          class="text-center"
        >
          <ul class="list-unstyled">
            <b-modal
              id="modalProfile"
              ref="modalProfile"
              :size="'md'"
              title="Profile"
              :ok-only="true"
            >
              <img
                class="modal-image"
                :src="serverUri + '/cdn/img?id=' + basic.photo + '&email=' + email"
              >
            </b-modal>
            <img
              :src="serverUri + '/cdn/img?id=' + basic.photo + '&email=' + email"
              class="photobox img-responsive img-thumbnail"
              @click="largePhoto()"
            >
          </ul>
          <p>
            <a
              v-if="!freezing"
              href="javascript:void(0)"
              @click="fileReset()"
            >
              다시 업로드
            </a>
          </p>
        </div>
      </b-col>
      <b-col md="9">
        <b-row>
          <b-col md="6">
            <b-form-group
              name="nameKrSet"
              label="한글 이름"
              label-for="nameKr"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-input
                v-model="basic.nameKr"
                v-validate.initial="veeNameKr"
                name="nameKr"
                :state="isValid('nameKr')"
                :disabled="freezing"
                placeholder="Korean Name"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              name="nameEnSet"
              label="영어 이름(있는 경우)"
              label-for="nameEn"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-input
                v-model="basic.nameEn"
                v-validate.initial="veeNameEn"
                name="nameEn"
                :state="basic.nameEn === ''? null : isValid('nameEn')"
                :disabled="freezing"
                placeholder="English Name"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              name="churchSet"
              label="출석 교회"
              label-for="church"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-input
                v-model="basic.church"
                v-validate.initial="veeRequired"
                name="church"
                :state="isValid('church')"
                :disabled="freezing"
                placeholder="현재 출석 교회"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              name="mobileSet"
              label="핸드폰(Mobile)"
              label-for="mobile"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-input
                v-model="basic.mobile"
                v-validate.initial="veeMobile"
                name="mobile"
                :state="isValid('mobile')"
                :disabled="freezing"
                placeholder="번호만 적어 주세요"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group
              name="genderSet"
              label="성별"
              label-for="gender"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-select
                v-model="basic.gender"
                v-validate.initial="veeRequired"
                name="gender"
                :state="isValid('gender')"
                :disabled="freezing"
              >
                <option>남(Male)</option>
                <option>여(Female)</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              name="kidSet"
              label="PK/MK/TCK"
              label-for="kid"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-select
                v-model="basic.kid"
                name="kid"
                :disabled="freezing"
              >
                <option>아님</option>
                <option>PK</option>
                <option>MK</option>
                <option>TCK</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <p class="form-group">
              생년월일(Birth): {{ koreanAge }} 세(만 {{ fullyAge }}세)
              <datepicker2
                id="dateInput"
                v-model="basic.birth"
                :language="ko"
                :open-date="new Date(birthday)"
                input-class="form-control"
                format="yyyy-MM-dd"
                width="100%"
                :disabled="freezing"
              />
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group
          name="addressBaseSet"
          label="주소(Base address)"
          label-for="addressBase"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="basic.addressBase"
            v-validate.initial="veeRequired"
            name="addressBase"
            :state="isValid('addressBase')"
            :disabled="freezing"
            placeholder="여기를 클릭해 주소 찾기!(Click here to find address.)"
            :readonly="true"
            @click.native="addressModalShow"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          name="addressDetailSet"
          label="상세 주소(Detail address)"
          label-for="addressDetail"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="basic.addressDetail"
            v-validate.initial="veeRequired"
            name="addressDetail"
            placeholder="상세 주소(Detail address)"
            :disabled="freezing"
            :state="isValid('addressDetail')"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'
import Datepicker2 from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'
import DaumPostcode from 'vuejs-daum-postcode'

const IMG_STATUS_INITIAL = 0
const IMG_STATUS_SAVING = 1
const IMG_STATUS_SUCCESS = 2
const IMG_STATUS_FAILED = 3
export default {
  name: 'RemnantBasic',
  components: { Datepicker2, DaumPostcode },
  props: {
    email: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      basic: {
        nameKr: '',
        nameEn: '',
        kid: '아님',
        gender: '',
        mobile: '',
        addressBase: '',
        addressDetail: '',
        church: '',
        photo: '',
        birth: ''
      },
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'image',
      ko: ko,
      serverUri: api.serverURI,
      currentFileStatus: IMG_STATUS_INITIAL,
      veeNameKr: {
        required: true,
        regex: /^(([가-힣])+)$/
      },
      veeNameEn: {
        regex: /^(|([A-z]+( [A-z]+)*))$/
      },
      veeRequired: {
        required: true
      },
      veeMobile: {
        required: true,
        regex: /^(([0][1][1769][0-9][0-9][0-9][0-9][0-9][0-9][0-9])|([0][1][0][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]))$/
      }
    }
  },
  computed: {
    isFileInitial () {
      return this.currentFileStatus === IMG_STATUS_INITIAL
    },
    isFileSaving () {
      return this.currentFileStatus === IMG_STATUS_SAVING
    },
    isFileSuccess () {
      return this.currentFileStatus === IMG_STATUS_SUCCESS
    },
    isFileFailed () {
      return this.currentFileStatus === IMG_STATUS_FAILED
    },
    datetime () {
      return new Date()
    },
    seventeenAgo () {
      let today = new Date()
      var todayYear = today.getFullYear()
      return String(todayYear - 17) + '-01-01'
    },
    koreanAge () {
      if (this.basic.birth) {
        let today = new Date()
        var birthYear = this.basic.birth.getFullYear()
        var todayYear = today.getFullYear()
        return todayYear - birthYear + 1
      }
      return 0
    },
    fullyAge () {
      if (this.basic.birth) {
        let today = new Date()
        var todayMonth = today.getMonth() + 1
        var todayDay = today.getDate()
        var todayYear = today.getFullYear()
        var month = this.basic.birth.getMonth() + 1
        var day = this.basic.birth.getDate()
        var year = this.basic.birth.getFullYear()

        let age = todayYear - year - 1
        if (todayMonth > month ||
            (todayMonth === month && todayDay >= day)) {
          age++
        }
        return age
      } else {
        return 0
      }
    },
    birthday () {
      if (this.basic.birth) {
        var month = this.basic.birth.getMonth() + 1
        var day = this.basic.birth.getDate()
        var year = this.basic.birth.getFullYear()

        if (month < 10) {
          month = '0' + month
        }
        if (day < 10) {
          day = '0' + day
        }
        return year + '-' + month + '-' + day
      } else {
        return this.seventeenAgo
      }
    },
    freezing () {
      return this.readOnly
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    } else {
      this.fileReset()
      this.$validator.reset()
    }
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    alertNotFound () {
      alert('등록된 정보가 없습니다!')
    },
    largePhoto () {
      this.$refs.modalProfile.show()
    },
    fileReset () {
      // reset form to initial state
      this.currentFileStatus = IMG_STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    fileSave (formData) {
      // upload data to the server
      this.currentFileStatus = IMG_STATUS_SAVING
      api.fileUpload(formData)
        .then(x => {
          this.uploadedFiles = [].concat(x)
          this.currentFileStatus = IMG_STATUS_SUCCESS
          this.basic.photo = this.uploadedFiles[0].id
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentFileStatus = IMG_STATUS_FAILED
          console.log('fail..' + this.uploadError)
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      var formData = new FormData()

      if (!fileList.length) {
        return
      }
      formData.append('email', this.email)
      formData.append('term', 'profile')
      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      // save it
      this.fileSave(formData)
    },
    setAddress: function (data) {
      this.basic.addressBase = '(' + data.zonecode + ') ' + data.address
      if (data.buildingName !== '') {
        this.basic.addressBase += ' (' + data.buildingName + ')'
      }
      this.$refs.addressModal.hide()
    },
    exportData (postArg) {
      postArg['name'] = {}
      Object.keys(this.basic).forEach(key => {
        if (key !== 'nameEn' && this.basic[key] === '') {
          postArg['ERROR'] = 'retry'
          if (key === 'photo') {
            postArg['ERROR'] = 'photo'
          } else if (key === 'birth') {
            postArg['ERROR'] = 'birth'
          }
          return postArg
        }

        if (key === 'gender') {
          postArg['gender'] = this.basic.gender === '남(Male)' ? 'M' : 'F'
        } else if (key === 'addressBase') {
          postArg['address'] = this.basic.addressBase + ':' + this.basic.addressDetail
        } else if (key === 'addressDetail') {
          // continue
        } else {
          postArg[key] = this.basic[key]
        }
      })
      return postArg
    },
    parseDetailInfo (data) {
      this.basic.birth = new Date(data.birth)
      this.basic.mobile = data.mobile
      this.basic.nameEn = data.name.en
      this.basic.nameKr = data.name.kr
      this.basic.gender = data.gender === 'M' ? '남(Male)' : '여(Female)'
      this.basic.photo = data.photo
      this.currentFileStatus = IMG_STATUS_SUCCESS
      this.basic.kid = data.kid
      this.basic.church = data.church
      this.basic.addressBase = data.address.split(':')[0]
      this.basic.addressDetail = data.address.split(':')[1]
    },
    getDetailInfo (info) {
      api.request('get', '/remnant/check?' + 'email=' + this.email + '&ic=basic&info=' + info)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          if (data.check === 1 && info === 1) {
            // 로그인 후 정보수정으로 들어옴
            this.parseDetailInfo(data)
            this.$validator.reset()
            // email잠구자
          } else {
            // insert
            // this.alertNotFound()
          }
        })
      this.$validator.reset()
    },
    addressModalShow () {
      this.$refs.addressModal.show()
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
.photobox {
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  max-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.modal-image {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
}
</style>
